import roles from '@constants/roles';
export default [
	{
		name: 'home',
		icon: 'home',
		title: 'Inicio',
		url: '/inicio',
		roles: [roles.Administrador, roles.Personal]
	},
	{
		name: 'catalogos',
		icon: 'th',
		title: 'Catálogos',
		url: '/catalogos',
		roles: [roles.Administrador],
		submenu: [
			{
				url: '/aspirantes',
				name: 'ASPIRANTES',
				title: 'Aspirantes',
				icon: 'alumnos.svg',
				description: 'REGISTRO DE ASPIRANTES DEL PLANTEL',
				roles: [roles.Administrador]
			},
			{
				url: '/personal',
				name: 'PERSONAL',
				title: 'Personal',
				icon: 'personal.svg',
				description: 'PERSONAL DOCENTE DEL PLANTEL',
				roles: [roles.Administrador]
			},
			{
				url: '/carreras',
				name: 'CARRERAS',
				title: 'Carreras',
				icon: 'carreras.svg',
				description: 'LICENCIATURAS Y POSGRADOS OFRECIDOS EN EL PLANTEL ',
				roles: [roles.Administrador]
			}
			// Al agregar otra opcion al menu de catalogos las descripciones estan en asana en la tarjeta de "Menú catálogos"
		]
	},

	{
		name: 'examenes',
		icon: 'file alternate outline',
		title: 'Exámenes',
		url: '/examenes',
		roles: [roles.Administrador],
		submenu: []
	},
	{
		name: 'bancosDePreguntas',
		icon: 'list alternate outline',
		title: 'Bancos de preguntas',
		url: '/bancosDePreguntas',
		roles: [roles.Administrador],
		submenu: []
	},
	{
		name: 'monitoreo',
		icon: 'video',
		title: 'Sala de monitoreo',
		url: '/monitoreo',
		roles: [roles.Administrador, roles.Personal],
		submenu: []
	},
	{
		name: 'configuraciones',
		icon: 'cogs',
		title: 'Configuraciones',
		url: '/configuraciones',
		roles: [roles.Administrador]
	}
];
